import {
  Grid,
  GridItem,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import {
  HiOutlineDotsVertical,
  HiOutlinePencil,
  HiOutlineTrash,
} from "react-icons/hi";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";

import { Cellular } from "src/common/icons/Cellular";
import { Loading } from "src/common/Loading";
import { PageContent } from "src/layout/PageContent";
import {
  PageHeader,
  PageHeaderBackLink,
  PageHeaderTitle,
} from "src/layout/PageHeader";
import { INTERCOMS_URL } from "src/routes/ProductUnits/Intercoms/index";
import { useIntercomQuery } from "src/routes/ProductUnits/Intercoms/queries";

export const IntercomDetails = () => {
  const { id } = useParams<"id">() as { id: string };
  const navigate = useNavigate();

  const intercomQuery = useIntercomQuery(id);
  if (intercomQuery.isLoading || !intercomQuery.data) {
    return <Loading />;
  }
  const data = intercomQuery.data;

  return (
    <>
      <PageHeader
        buttons={
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Actions"
              icon={<HiOutlineDotsVertical />}
              variant="clear"
            >
              Actions
            </MenuButton>
            <MenuList>
              <MenuItem
                justifyContent="space-between"
                onClick={() => {
                  navigate(`/product-units/intercoms/${id}/edit`);
                }}
              >
                Edit Intercom
                <HiOutlinePencil />
              </MenuItem>
              {data.cellKitId ? (
                <MenuItem
                  justifyContent="space-between"
                  onClick={() => {
                    navigate(
                      `/product-units/cell-kits/${data.cellKitId}/details`
                    );
                  }}
                >
                  Access Cell Kit Details
                  <Cellular />
                </MenuItem>
              ) : null}
              <MenuItem isDisabled justifyContent="space-between">
                Remove Intercom
                <HiOutlineTrash />
              </MenuItem>
            </MenuList>
          </Menu>
        }
      >
        <PageHeaderBackLink>
          <Link as={RouterLink} to={INTERCOMS_URL}>
            &#8249; Back to list
          </Link>
        </PageHeaderBackLink>
        <PageHeaderTitle>Intercom Details</PageHeaderTitle>
      </PageHeader>
      <PageContent>
        <Grid templateColumns={"1fr 2fr"} gap={4}>
          <GridItem>Intercom Model</GridItem>
          <GridItem>
            <Text fontWeight={600}>{data.intercomModel}</Text>
          </GridItem>

          <GridItem>
            <Text>Serial Number</Text>
          </GridItem>
          <GridItem>
            <Text fontWeight={600}>{data.serialNumber}</Text>
          </GridItem>

          <GridItem>
            <Text>Entry Point ID</Text>
          </GridItem>
          <GridItem>
            <Text fontWeight={600}>{data.entryPointId}</Text>
          </GridItem>

          <GridItem>
            <Text>Notes</Text>
          </GridItem>
          <GridItem>
            <Text fontWeight={600}>{data.notes}</Text>
          </GridItem>

          <GridItem>
            <Text>Auth Token</Text>
          </GridItem>
          <GridItem>
            <Text fontWeight={600}>{data.authToken}</Text>
          </GridItem>
        </Grid>
      </PageContent>
    </>
  );
};
